import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ArrowBackIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.59815 14.4511C6.5961 14.4491 6.59409 14.4471 6.59205 14.445L0.290953 8.15221C0.241223 8.10221 0.197054 8.04696 0.159178 7.98746L0.0603372 7.80627L0.0191407 7.68272L0.0191407 7.5921C-0.00638024 7.45326 -0.00638024 7.31091 0.0191407 7.17203L0.0191407 7.08967L0.0191407 6.99083L0.0932713 6.85079C0.135665 6.77276 0.18829 6.70072 0.249756 6.63663L6.59205 0.319084C7.01173 -0.103962 7.69493 -0.106703 8.11798 0.312983C8.12002 0.314991 8.12203 0.317037 8.12408 0.319084C8.53095 0.745527 8.53095 1.41641 8.12408 1.84289L4.36813 5.60706C4.20891 5.76945 4.21145 6.03022 4.37388 6.18945C4.44944 6.26354 4.5506 6.3057 4.65643 6.30717H16.9209C17.5168 6.30713 18 6.79018 18 7.38612C18 7.98206 17.517 8.46514 16.9211 8.46522H16.9209H4.65643C4.42902 8.46842 4.24721 8.65537 4.25041 8.88278C4.25192 8.98857 4.29404 9.08977 4.36813 9.16533L8.12408 12.913C8.5362 13.3406 8.5362 14.0176 8.12408 14.4451C7.70439 14.8681 7.02119 14.8709 6.59815 14.4511Z"
        fill="currentColor"
      />
    </svg>
  )
})

ArrowBackIcon.displayName = 'ArrowBackIcon'
